import React, { Component } from 'react';
import logo from './images/KORU-logo.png';
import './styles/App.css';
// import RMSProfile from './RMSProfile';
import RMSSelectSyringeDriver from './RMSSelectSyringeDriver';
import RMSSelectDrug from './RMSSelectDrug';
import RMSDosage from './RMSDosage';
import RMSResults from './RMSResults';
import RMSProfile from './RMSProfile';
import VersionSelection from './VersionSelection';
import { Cookies } from 'react-cookie';

class Home extends Component {
  constructor(props) {
    super(props);

    this.state = {
      page: '',
      selectedSyringe: {},
      selectedDrug: {},
      selectedDosage: '',
      selectedWeight: '',
      selectedVersion: 'us',
      dbItemId: '',
    };

    this.changePage = this.changePage.bind(this);
  }

  componentWillMount() {
    // ---------------  Bypass Login ---------------------
    // this.props.validateToken().then(()=>{
    //     this.props.validateUser().then(() => {
    //         this.setState({page: 'RMSSelectSyringeDriver'});
    //     }, () => {
    //         this.setState({page: 'RMSProfile'});
    //     });
    // }, () => {
    //     window.location.replace('/');
    // });

    // const cookies = new Cookies();
    // const versionCookie = cookies.get('version');
    // if (versionCookie) {
    //   this.setState({
    //     selectedVersion: versionCookie,
    //     page: 'RMSSelectSyringeDriver',
    //   });
    // } else {
    this.setState({ page: 'VersionSelection' });
    // }
  }

  changePage(page) {
    this.setState({ page: page });
  }

  setSelectedSyringe(item) {
    this.setState({ selectedSyringe: item });
  }

  setSelectedDrug(item) {
    this.setState({ selectedDrug: item });
  }

  setSelectedDosage(item) {
    this.setState({ selectedDosage: item });
  }

  setDbItemId(id) {
    this.setState({ dbItemId: id });
  }

  setWeight = (value) => {
    this.setState({
      selectedWeight: value,
    });
  };

  setVersion = (value) => {
    this.setState({
      selectedVersion: value,
      page: 'RMSSelectSyringeDriver',
    });
  };

  render() {
    let content = '';

    switch (this.state.page) {
      case 'RMSSelectSyringeDriver':
        content = (
          <RMSSelectSyringeDriver
            changePage={this.changePage}
            setSelectedSyringe={(item) =>
              this.setSelectedSyringe(item)
            }
            version={this.state.selectedVersion}
          />
        );
        break;
      case 'RMSSelectDrug':
        content = (
          <RMSSelectDrug
            changePage={this.changePage}
            setDbItemId={(id) => this.setDbItemId(id)}
            setSelectedDrug={(item) => this.setSelectedDrug(item)}
            selectedDrug={this.state.selectedDrug}
            setSelectedDosage={(item) => this.setSelectedDosage(item)}
            setWeight={(value) => this.setWeight(value)}
            selectedWeight={this.state.selectedWeight}
            selectedSyringe={this.state.selectedSyringe}
            version={this.state.selectedVersion}
          />
        );
        break;
      case 'RMSDosage':
        content = (
          <RMSDosage
            changePage={this.changePage}
            selectedDrug={this.state.selectedDrug}
            setSelectedDosage={(item) => this.setSelectedDosage(item)}
            version={this.state.selectedVersion}
          />
        );
        break;
      case 'RMSResults':
        content = (
          <RMSResults
            changePage={this.changePage}
            selectedSyringe={this.state.selectedSyringe}
            selectedDrug={this.state.selectedDrug}
            selectedDosage={this.state.selectedDosage}
            selectedWeight={this.state.selectedWeight}
            dbItemId={this.state.dbItemId}
            version={this.state.selectedVersion}
          />
        );
        break;
      case 'RMSProfile':
        content = (
          <RMSProfile
            changePage={this.changePage}
            updateUserData={(data) => this.props.updateUserData(data)}
            version={this.state.selectedVersion}
          />
        );
        break;
      case 'VersionSelection':
        content = (
          <VersionSelection
            changePage={this.changePage}
            setVersion={this.setVersion}
          />
        );
        break;
    }

    return (
      <div>
        {/*<div className="site-header">*/}
        {/*<div className="site-logo">*/}
        {/*<a title="RMS Home" href="/">*/}
        {/*<img src={logo} alt="RMS logo"/>*/}
        {/*</a>*/}
        {/*</div>*/}
        {/*</div>*/}
        <div className="container-fluid">
          <div className="row site-header">
            <div className="col-lg-12 col-xs-12 site-logo">
              <a title="KORU Home" href="/">
                <img src={logo} alt="KORU logo" />
              </a>
            </div>
          </div>
          <div className="row site-content">
            <div className="col-lg-12 col-xs-12">{content}</div>
          </div>
        </div>
      </div>
    );
  }
}

export default Home;



// WEBPACK FOOTER //
// ./src/Home.js